var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWithText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 167.4 209.5",
    style: {
      enableBackground: "new 0 0 167.4 209.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000109009023073750712620000005035679322992024965_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000071539377489298865480000007492900457186719648_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M142.6,0h-15.9v150.5h15.9V0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.2,60.6v-3.1L81,68.6l10.2,11.1v-3.1h13.3v74.3h15.9V76.6V60.7v-0.1H91.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.3,0h-15.9v54h15.9V0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.8,150.8h15.9V0.2H24.8V150.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.2,90.2v3.1l10.2-11.1L76.2,71.1v3.1H62.9V0H47v74.3v15.9v0.1L76.2,90.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.1,150.8H63v-54H47.1V150.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "19.6,192.7 2.4,192.7 2.4,185.1 0,185.1 0,192.7 0,192.7 0,194.9 0,194.9 0,209.5 2.4,209.5      2.4,194.9 19.6,194.9 19.6,209.5 22,209.5 22,185.1 19.6,185.1    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "57.4,185.1 55.1,185.1 55.1,209.5 72.8,209.5 72.8,207.3 57.4,207.3    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "90.3,187.3 89.4,185.1 76.9,185.1 76.9,209.5 79.2,209.5 79.2,197.9 87.4,197.9 87.4,195.7      79.2,195.7 79.2,187.3    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "128,185.1 118.7,206 113.7,194.9 111.2,194.9 105.9,206 96.9,185.1 94.4,185.1 104.9,209.5      106.9,209.5 112.4,197.1 117.8,209.5 119.7,209.5 130.6,185.1    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "164.4,185.1 154.4,195.7 144.4,185.1 141.3,185.1 153.2,197.8 153.2,209.5 155.6,209.5 155.6,197.8      167.4,185.1    "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.4,185.1l-11.7,24.4h2.7l5.8-12.2h8.3l5.7,12.2h2.6l-11.3-24.4H135.4L135.4,185.1z M133.4,194.9l3-6.3     l2.9,6.3H133.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.7,185.1L26,209.5h2.7l5.8-12.2h8.3l5.7,12.2h2.6l-11.4-24.4H37.7z M35.7,194.9l3-6.3l2.9,6.3H35.7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWithText);
export default __webpack_public_path__ + "static/media/logoWithText.c0209d6ca9a0ed6eb5cd9713394c5a63.svg";
export { ForwardRef as ReactComponent };